import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sum',
  pure: false
})
export class SumPipe implements PipeTransform {

  transform(items: any[], attr1: string, attr2: string = null): any {
    if (attr2 != null) {
      return !items ? 0 : items.filter(x => x[attr1] != null).reduce((a, b) => a + (parseFloat(b[attr1].toString().replace(/\,/, '')) * parseFloat(b[attr2].toString().replace(/\,/, ''))), 0);
    } else {
      return !items ? 0 : items.filter(x => x[attr1] != null).reduce((a, b) => a + (parseFloat(b[attr1].toString().replace(/\,/, ''))), 0);
    }
  }
}
